// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PriceCalculator from "../../core/PriceCalculator.res.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

let CatalogVariantRetailPriceReducer_CouldNotUpdatePrice = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantRetailPriceReducer.CatalogVariantRetailPriceReducer_CouldNotUpdatePrice");

function make(state, action) {
  switch (action.TAG) {
    case "RetailPriceUpdated" :
      let nextValueExcludingTax = action._1;
      let variant = action._0;
      return state.map(retailPrice => {
        if (retailPrice.id === variant.id && retailPrice.priceId === variant.priceId && retailPrice.variantId === variant.variantId) {
          return {
            id: retailPrice.id,
            priceId: retailPrice.priceId,
            variantId: retailPrice.variantId,
            shopName: retailPrice.shopName,
            name: retailPrice.name,
            valueExcludingTax: nextValueExcludingTax,
            valueIncludingTax: PriceCalculator.Retail.Tax.add(nextValueExcludingTax, retailPrice.taxRate),
            taxRate: retailPrice.taxRate,
            taxIncluded: retailPrice.taxIncluded,
            purchasePrice: retailPrice.purchasePrice,
            toQuantity: retailPrice.toQuantity,
            fromQuantity: retailPrice.fromQuantity,
            capacityUnit: retailPrice.capacityUnit,
            edited: true
          };
        } else {
          return retailPrice;
        }
      });
    case "RetailPricesPurchaseValueUpdated" :
      let newState = action._0;
      return state.map(retailPrice => {
        let match = newState.find(current => {
          if (current.id === retailPrice.id && current.priceId === retailPrice.priceId) {
            return current.variantId === retailPrice.variantId;
          } else {
            return false;
          }
        });
        return {
          id: retailPrice.id,
          priceId: retailPrice.priceId,
          variantId: retailPrice.variantId,
          shopName: retailPrice.shopName,
          name: retailPrice.name,
          valueExcludingTax: retailPrice.valueExcludingTax,
          valueIncludingTax: retailPrice.valueIncludingTax,
          taxRate: retailPrice.taxRate,
          taxIncluded: retailPrice.taxIncluded,
          purchasePrice: match !== undefined ? match.purchasePrice : retailPrice.purchasePrice,
          toQuantity: retailPrice.toQuantity,
          fromQuantity: retailPrice.fromQuantity,
          capacityUnit: retailPrice.capacityUnit,
          edited: retailPrice.edited
        };
      });
    case "Reset" :
      return action._0;
  }
}

export {
  CatalogVariantRetailPriceReducer_CouldNotUpdatePrice,
  make,
}
/* PriceCalculator Not a pure module */
